import React from "react";
import "../assets/css/sections.css";

const VALUES = [
  "Locally raised",
  "No middlemen",
  "Whole-animal sourcing",
  "Calgary delivery",
  "Community pricing",
  "Farmers you can name",
  "Seasonal & fresh",
];

const ValueStrip = () => (
  <section className="value-strip" aria-label="What we stand for">
    {/* The list is duplicated so the marquee can loop seamlessly; the copy is
        hidden from assistive tech to avoid reading everything twice. */}
    <div className="value-track">
      {[0, 1].map((copy) => (
        <ul className="value-row" key={copy} aria-hidden={copy === 1 ? "true" : undefined}>
          {VALUES.map((value) => (
            <li key={value}>
              <span className="value-dot" aria-hidden="true" />
              {value}
            </li>
          ))}
        </ul>
      ))}
    </div>
  </section>
);

export default ValueStrip;
